export const FLIGHT_DETAILS_CLICKED = 'FLIGHT_DETAILS_CLICKED';
export const FLIGHT_DETAILS_CLICKED_VERSION = '1.1';

export type FlightDetailsClickedPayload = {
  productDetailKey: string;
  searchId: string;
  flightClickId: string;
};

export type FlightDetailsClickedParams = {
  searchId: string;
  productDetailKey: string;
  flightClickId: string;
};

export const createFlightDetailsClickedPayload = (params: FlightDetailsClickedParams): FlightDetailsClickedPayload => {
  const { searchId, productDetailKey, flightClickId } = params;

  return {
    searchId,
    productDetailKey,
    flightClickId,
  };
};
